import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../useAuth';

const BANNER_HEIGHT = 37;

const ImpersonationBanner: React.FC = () => {
  const { impersonating, exitImpersonation } = useAuth();
  const navigate = useNavigate();

  if (!impersonating) return null;

  const displayName =
    [impersonating.firstName, impersonating.lastName].filter(Boolean).join(' ') ||
    impersonating.email;

  const handleExit = async () => {
    await exitImpersonation();
    navigate(`/admin/users/${impersonating.id}/view`);
  };

  return (
    <React.Fragment>
      {/* Spacer: same height as banner so navbar isn't hidden behind it */}
      <div style={{ height: BANNER_HEIGHT, flexShrink: 0 }} aria-hidden="true" />
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          background: '#92400e',
          color: '#fef3c7',
          padding: '8px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '0.875rem',
          fontFamily: 'IBM Plex Sans, sans-serif',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        }}
      >
        <span>
          <strong style={{ marginRight: 6 }}>Admin View Mode</strong>
          {' — You are viewing the app as '}
          <strong>{displayName}</strong>
          <span style={{ opacity: 0.75, marginLeft: 6 }}>({impersonating.email})</span>
        </span>
        <button
          onClick={handleExit}
          style={{
            background: '#fef3c7',
            color: '#92400e',
            border: 'none',
            borderRadius: 4,
            padding: '4px 14px',
            fontWeight: 700,
            fontSize: '0.8rem',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          ← Exit to Admin
        </button>
      </div>
    </React.Fragment>
  );
};

export default ImpersonationBanner;
